import { IGameLabels } from '@interlayer/js/components/common/Game/sun/components/LabelsFeatureIcons/types';

const formatDate = (date?: string): number => {
    const time = date ? new Date(date) : new Date();
    time.setHours(0, 0, 0, 0);

    return time.getTime();
};

export const calculateDaysUntilExpiration = (date?: string): number => {
    const dayMilliseconds = 86_400_000; // milliseconds in one day
    const today = formatDate();
    const targetDate = formatDate(date);

    return targetDate <= today
        ? 0
        : Math.floor((targetDate - today) / dayMilliseconds);
};

export const parseExpirationDates = (
    description: string,
    name: string,
    code: string
): Record<keyof IGameLabels, string> | Record<string, never> => {
    try {
        return JSON.parse(description)?.expirationDate || {};
    } catch (error) {
        console.error(`Invalid JSON structure for game (name: ${name}, code: ${code}). Please check the description.`);

        return {};
    }
};
